document.addEventListener('DOMContentLoaded', function() {
  const input = document.getElementById('brandSearchInput');
  const searchBtn = document.getElementById('brandSearchBtn');
  const resetBtn = document.getElementById('brandResetBtn');
  const filterBtns = document.querySelectorAll('.filter-btn');
  const brandItems = document.querySelectorAll('.brand-item');

  if (!brandItems.length) return;

  function filterBrands(searchTerm, letter) {
    brandItems.forEach(item => {
      const title = item.textContent.trim().toLowerCase();
      const startsWith = letter 
        ? (letter instanceof RegExp ? letter.test(title) : title.startsWith(letter.toLowerCase()))
        : true;
      const containsSearch = searchTerm ? title.includes(searchTerm.toLowerCase()) : true;
      item.style.display = (startsWith && containsSearch) ? 'block' : 'none';
    });
  }

  searchBtn?.addEventListener('click', () => filterBrands(input.value, null));
  input?.addEventListener('keyup', e => { if (e.key === 'Enter') filterBrands(input.value, null); });

  resetBtn?.addEventListener('click', () => {
    input.value = '';
    brandItems.forEach(item => item.style.display = 'block');
  });

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const letter = btn.textContent;
      filterBrands(input.value, letter === '0-9' ? /^[0-9]/i : letter);
    });
  });
});
